<template>
  <div class="catalog-form" style="position: relative; display: flex; flex-direction: column;">
    <h1 id="init">
      <i class="fal fa-arrow-circle-left" @click="onCancel" title="Regresar"></i>
      <span>{{ title }}</span>
    </h1>

    <b-row class="workspace-actions" v-if="createPermission || updatePermission">
      <b-col>
        <b-button class="workspace-action"
          variant="light"
          @click="updateItem"
          :disabled="formOpen || !workspaceSelected.id || !updatePermission">
            <i class="fal fa-file-edit"></i> Modificar</b-button>
        <b-button class="workspace-action"
         variant="light"
          @click="displayChangeOwnerModal"
          :disabled="formOpen || !workspaceSelected.id || workspaceSelected.owner || !updatePermission">
            <i class="fal fa-user-shield"></i> Establecer como dueño</b-button>
        <b-button class="workspace-action"
          v-if="!isIndividualDomainWithBLUE"
          variant="light"
          @click="newItem"
          :disabled="formOpen || !createPermission">
            <i class="fal fa-user-tag"></i> Agregar razón social</b-button>
      </b-col>
    </b-row>

    <div class="form-area full-width" :class="{ collapsed: formOpen }">
      <b-card class="form-section" v-if="id">
        <table class="table table-responsive-xl table-hover table-bordered workspaces-table" style="margin: 0" v-if="workspaces.length">
          <thead>
            <tr>
              <th scope="col">Dueño</th>
              <th scope="col">Cliente</th>
              <th scope="col">Estado (Workspace)</th>
              <th scope="col" v-if="!formOpen">Día de facturación</th>
              <th scope="col" v-if="!formOpen">Día consolidado en factura</th>
              <th scope="col" v-if="!formOpen">Contacto</th>
              <th scope="col" v-if="!formOpen">Teléfono</th>
              <th scope="col" v-if="!formOpen">Correo electrónico</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="it in workspaces" :key="it.id" @click="workspaceSelected = formOpen ? workspaceSelected : it" :class="{ selected:  workspaceSelected === it }">
              <td style="width: 15px"><i class="fas fa-user-shield" v-if="it.owner"></i></td>
              <td style="max-width: 200px">{{ it.client.clientCode }} {{ it.client.name }}</td>
              <td>{{ getWorkspaceStatusDescription(it.status) }}</td>
              <td style="width: 150px" v-if="!formOpen">{{ it.facturationDate }}</td>
              <td style="width: 210px" v-if="!formOpen">{{ it.consolidatedInvoice ? 'Sí' : 'No' }}</td>
              <td v-if="!formOpen">{{ it.contact.name }}</td>
              <td v-if="!formOpen">{{ it.contact.contactTelephone }}</td>
              <td v-if="!formOpen">{{ it.contact.contactEmail }}</td>
            </tr>
          </tbody>
        </table>

        <div class="no-data" v-else>
          <h5 style="opacity: 0.4; margin: 0;">No existen razones sociales relacionadas a este dominio</h5>
        </div>
      </b-card>
    </div>

    <!-- FORMULARIO ALTA/MODIFICACION DE WORKSPACE -->
    <div class="workspace-form-modal animate__animated animate__fadeInRight animate__faster" v-if="formOpen">
      <h5>Datos de relación Dominio - Cliente</h5>
      <small class="text-info" v-show="workspaces.length === 0">El primer workspace del dominio será marcado como <span class="font-weight-bold">owner</span> automáticamente.</small>
      <b-form @submit.stop.prevent="onSubmit">
        <b-form-group
          id="input-group-client"
          label="Cliente *"
          label-for="input-client"
          style="position: relative">
          <b-form-input
            id="input-client"
            name="input-client"
            type="text"
            class="shadow-none"
            placeholder="Seleccione el cliente"
            v-model.trim="searchClient"
            :maxlength="255"
            autocomplete="off"
            @click="showClientSelection(true)"
            @focus="showClientSelection(true)"
            @blur="showClientSelection(false)"
            :disabled="!!workspaceSelected.id">
          </b-form-input>
          <div class="dropdown-input-selection-list" v-if="clientSelectionOpen">
            <table class="table">
              <tbody>
                <tr v-for="it in clients" :key="it.code" @click="selectClient(it)" v-show="isMatchClient(it)">
                  <th scope="row" style="width: 125px">{{ it.code }}</th>
                  <td>{{ it.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-form-group>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <b-form-group id="input-group-status" label="Estado">
              <b-form-select
                id="input-select-status"
                name="input-select-status"
                class="shadow-none"
                v-model="form.status"
                :options="workspacesStatus"
                :disabled="true">
              </b-form-select>
            </b-form-group>
          </div>

          <div class="col-sm-12 col-md-6">
            <b-form-group id="input-group-facturation-date" label="Día de facturación">
              <b-form-select
                id="input-select-facturation-date"
                name="input-select-facturation-date"
                class="shadow-none"
                v-model="form.facturationDate"
                :options="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]">
              </b-form-select>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <b-form-group
              id="input-group-contact-name"
              label="Contacto *"
              label-for="input-contact-name">
              <b-form-input
                id="input-contact-name"
                name="input-contact-name"
                type="text"
                class="shadow-none"
                placeholder="Nombre del contacto"
                v-model.trim="form.contact.name"
                :maxlength="255"
                v-validate="{ required: true }"
                :state="validateState('input-contact-name')"
                aria-describedby="input-contact-name-feedback"
                :disabled="readOnly">
              </b-form-input>
              <b-form-invalid-feedback id="input-contact-name-feedback">El nombre del contacto es requerido</b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div class="col-sm-12 col-md-6">
            <b-form-group
              id="input-group-email"
              label="Correo electrónico *"
              label-for="input-email">
              <b-form-input
                id="input-email"
                name="input-email"
                type="email"
                class="shadow-none"
                placeholder="Correo electrónico"
                v-model.trim="form.contact.contactEmail"
                :maxlength="255"
                v-validate="{ required: true, email: true  }"
                :state="validateState('input-email')"
                aria-describedby="input-email-feedback"
                :disabled="readOnly">
              </b-form-input>
              <b-form-invalid-feedback id="input-email-feedback">Introduzca un correo válido</b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div class="col-sm-12 col-md-6">
            <b-form-group
              id="input-group-phone"
              label="Teléfono *"
              label-for="input-phone">
              <b-form-input
                id="input-phone"
                name="input-phone"
                type="text"
                class="shadow-none"
                placeholder="Ej. 5537081925, +525537081925"
                v-model.trim="form.contact.contactTelephone"
                :maxlength="16"
                v-validate="{ required: true, regex: regexPhone  }"
                :state="validateState('input-phone')"
                aria-describedby="input-phone-feedback"
                :disabled="readOnly">
              </b-form-input>
              <b-form-invalid-feedback id="input-phone-feedback">Introduzca un teléfono válido</b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>

        <b-form-group>
          <b-form-checkbox v-model="form.consolidatedInvoice">Detalle consolidado en factura</b-form-checkbox>
        </b-form-group>

        <!-- ACCIONES -->
        <div class="text-right" v-show="!loading">
          <b-button class="mr-2" @click="showForm(false)">Cancelar</b-button>
          <b-button type="submit" variant="primary" v-if="!readOnly">Guardar</b-button>
        </div>
      </b-form>
    </div>

    <!-- Confirmation modal to change owner -->
    <div class="change-domain-owner__modal"
      :class="{ 'active': displayChangeOwnerMessage }">
      <div class="content">
        <div class="modal__header">
          <p>Cambio de dueño</p>
          <button class="btn btn-light btn-lg" @click="displayChangeOwnerModal"><i class="far fa-times"></i></button>
        </div>
        <p class="confirmation-messsage">
          Estás por asignar el cliente
          <span v-if="workspaceSelected !== undefined && workspaceSelected.client !== undefined" class="client">{{ workspaceSelected.client.name }}</span> como dueño al dominio
          <span v-if="domain !== undefined" class="domain">{{ domain.name }}</span>.
        </p>
        <div class="col-auto p-4">
          Por favor, marca la casilla para confirmar.
          <div class="confirm-message custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="confirmChange" v-model="confirmChangeOwner">
            <label class="custom-control-label" for="confirmChange">Confirmar cambio</label>
          </div>
        </div>
        <div class="actions w-100">
          <button class="cancel w-50 btn btn-light" @click="displayChangeOwnerModal">Cancelar</button>
          <button class="confirm w-50 btn btn-primary" :disabled="!confirmChangeOwner" @click="saveAsOwner">Cambiar dueño</button>
        </div>
        <LoadingMask :active="changingOwner"></LoadingMask>
      </div>
    </div>

    <!-- Toast to show complet events -->
    <div class="owner-toast toast success"
      :class="{ show: ownerChanged }"
      role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <strong class="mr-auto">Cambio de cliente.</strong>
        <button type="button" class="ml-2 mb-1 close"
          @click="ownerChanged = false"
          data-dismiss="toast" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="toast-body">
        <p>
          El cambio de cliente se ha realizado correctamente.
        </p>
      </div>
    </div>

    <LoadingMask :active="loading"/>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Client, Workspace, ClientWorkspacesFilters, DomainCatalogGridItem, BLUEMESSAGING_ID, WorkspaceStatus } from '@/types/Catalogs'
import DateSelector from '@/components/generic/DateSelector.vue'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import catalogsService from '@/services/CatalogsService'
import { PermissionNames, RoleNames } from '@/types/Auth'
import userInfoStore from '@/store/userInfo'
import { PageRequest } from '@/types/Support'
import MessageService from '@/services/support/MessageService'
import LogService, { ToString } from '@/services/support/LogService'
import { MessageError } from '../generic/MessageHandling.vue'

@Component({
  components: {
    DateSelector,
    LoadingMask
  }
})
export default class AdminWorkspacesFromDomains extends Vue {
  @Prop({ required: true, default: 0 })
  id: number

  @Prop({ required: true, default: new DomainCatalogGridItem() })
  domain: DomainCatalogGridItem

  @Prop({ required: true, default: '' })
  title: number

  @Prop({ required: true, default: [] })
  clients: any[]

  @Prop({ required: false, default: false })
  readOnly: number

  MAX_WORKSPACES_FOR_INDIVIDUAL_DOMAIN = 2
  PAGE_SIZE = 500
  formOpen = false
  clientSelectionOpen = false
  loading = false
  clientSelected: any = {}
  clientSelectedBackup: any = {}
  workspaces: Workspace[] = []
  workspaceSelected = new Workspace()
  workspacesStatus = [
    { value: WorkspaceStatus.ACTIVE, text: 'Activo', disabled: true },
    { value: WorkspaceStatus.INACTIVE, text: 'Baja', disabled: true },
    { value: WorkspaceStatus.SUSPENDED, text: 'Suspendido', disabled: true }
  ]
  searchClient = ''
  form = Workspace.getIntanceForEdit()

  regexPhone = /^[+]?[0-9]{10,15}$/
  displayChangeOwnerMessage: boolean = false
  confirmChangeOwner: boolean = false
  ownerChanged: boolean = false
  changingOwner: boolean = false

  mounted () {
    this.init()
  }

  get createPermission () {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === PermissionNames.WORKSPACES_CREATE)
  }

  get updatePermission () {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === PermissionNames.WORKSPACES_UPDATE)
  }

  get userHasFinancesAdminRole () {
    return userInfoStore.hasRole(RoleNames.FINANCES_ADMIN)
  }

  /**
   * Validates if the current domain is INDIVIDUAL and
   * it has at least two clients where one of them is BLUEMESSAGING
   */
  get isIndividualDomainWithBLUE () {
    return this.domain.isIndividual() &&
      this.workspaces.length === this.MAX_WORKSPACES_FOR_INDIVIDUAL_DOMAIN &&
      this.isClientInWorkspaces(BLUEMESSAGING_ID)
  }

  /**
   * Validates if one client is already in the workspaces of the current domain
   *
   * @param clientId to check
   * @return true if the clientId is in some of the workspaces
   */
  isClientInWorkspaces (clientId: number): boolean {
    return this.workspaces.some((w: Workspace) => w.client.id === clientId)
  }

  init () {
    this.workspaces = []
    const pageRequest = new PageRequest<ClientWorkspacesFilters>(this.PAGE_SIZE)
    pageRequest.filters.domainId = this.id
    this.loadWorkspacesPage(pageRequest)
  }

  newItem () {
    this.workspaceSelected = Workspace.getIntanceForEdit()
    this.form = this.workspaceSelected
    this.searchClient = ''
    this.showForm(true)
    setTimeout(() => {
      document.getElementById('input-client')!.focus()
    }, 500)
  }

  updateItem () {
    this.form = JSON.parse(JSON.stringify(this.workspaceSelected))
    const client = this.clients.find((it: Client) => it.id === this.workspaceSelected.client.id)
    this.selectClient(client)
    this.showForm(true)
  }

  showForm (flag: boolean) {
    if (flag) {
      this.clientSelectedBackup = {}
      this.formOpen = true
    } else {
      this.formOpen = false
    }
  }

  showClientSelection (flag: boolean) {
    if (flag) {
      this.searchClient = ''
      this.clientSelected = {}
      this.clientSelectionOpen = true
    } else {
      setTimeout(() => {
        this.clientSelectionOpen = false
        if (this.clientSelectedBackup.code) {
          this.selectClient(this.clientSelectedBackup)
        }
      }, 200)
    }
  }

  loadWorkspacesPage (pageRequest: PageRequest<any>) {
    catalogsService.getWorkspacesByDomain(pageRequest).then(response => {
      this.workspaces.push(...response.results)

      if (this.workspaces.length < response.total) {
        pageRequest.page++
        this.loadWorkspacesPage(pageRequest)
      } else {
        this.$emit('workspacesLoaded', this.workspaces)
      }
    }).catch((error) => {
      LogService.error(`Error en la carga de Workspaces: ${ToString(error.response ?? error)}`)
    })
  }

  isMatchClient (client: any) {
    if (client.status !== WorkspaceStatus.ACTIVE) return false
    if (this.workspaces.length) {
      // Hide all clients that had already been related to this domain
      let clientIds = this.workspaces.map((w) => w.client.id)
      if (clientIds.includes(client.id)) return false
    }

    // If is an individual domain with at least one workspace that isn't
    // BLUEMESSAGING, only can select BLUEMESSAGING client
    if (this.domain.isIndividual() &&
      this.workspaces.length &&
      !this.isClientInWorkspaces(BLUEMESSAGING_ID) &&
      client.id !== BLUEMESSAGING_ID) return false

    if (!this.searchClient) return true

    // Match the client name
    const regexSearch = new RegExp(this.searchClient, 'i')
    return regexSearch.test(client.code) || regexSearch.test(client.name)
  }

  selectClient (client: any) {
    this.clientSelected = client
    this.clientSelectedBackup = client
    this.searchClient = client.code + ' ' + client.name
  }

  getWorkspaceStatusDescription (status: string) {
    return Workspace.getStatusDescription(status)
  }

  validateState (ref: any) {
    const thiz = this as any
    if (
      thiz.veeFields[ref] &&
      (thiz.veeFields[ref].dirty || thiz.veeFields[ref].validated)
    ) {
      return !thiz.veeErrors.has(ref)
    }
    return null
  }

  onSubmit () {
    if (!this.clientSelected.code) {
      MessageService.error('Validación de formulario', 'Debe elegir un cliente', 3000)
      return
    }
    this.form.domain.id = this.id
    this.form.client.id = this.clientSelected.id

    this.$validator.validateAll().then(result => {
      if (result) {
        this.loading = true
        // If it's a new item and there are no workspaces yet, then the item is set as owner
        if (!this.form.id && !this.workspaces.length) {
          if (!this.userHasFinancesAdminRole && this.form.client.id === BLUEMESSAGING_ID) {
            this.$bvToast.toast(
              'Lo sentimos, no se puede asociar a Bluemessaging como owner del dominio. Por favor, seleccione otro cliente que será owner de este dominio o contacte al Gerente de Fiananzas.',
              {
                title: 'Asignación no autorizada.',
                variant: 'danger',
                autoHideDelay: 10000
              }
            )
            this.loading = false
            return
          }
          this.form.owner = true
        }

        catalogsService.saveWorkspace(this.form).then((response: Client) => {
          this.init()
          this.showForm(false)
          this.$bvToast.toast(
            'El Workspace se agregado correctamente.',
            {
              title: 'Workspace completado.',
              variant: 'success',
              autoHideDelay: 6000
            }
          )
        }).catch(() => {
          MessageService.error('Error al guardar', 'No fue posible asociar la razón social')
        }).finally(() => {
          this.loading = false
        })
      }
    })
  }

  async saveAsOwner () {
    this.changingOwner = true
    if (this.workspaceSelected.owner) return

    if (!this.userHasFinancesAdminRole && this.workspaceSelected.client.id === BLUEMESSAGING_ID) {
      this.changingOwner = false
      this.displayChangeOwnerModal()
      this.$bvToast.toast(
        'Lo sentimos, no puede asociar a Bluemessaging como owner del dominio. Por favor, seleccione otro cliente que será owner de este dominio o contacte al Gerente de Fiananzas.',
        {
          title: 'Asignación no autorizada.',
          variant: 'danger',
          autoHideDelay: 10000
        }
      )
      return
    }

    for (let it of this.workspaces) {
      if (it.owner) {
        await catalogsService.saveWorkspaceOwner(it.id, false)
        it.owner = false
      }
    }
    await catalogsService.saveWorkspaceOwner(this.workspaceSelected.id, true)
      .then(() => {
        this.displayChangeOwnerModal()
        this.ownerChanged = true
        this.workspaceSelected.owner = true
        this.$bvToast.toast(
          'Se ha cambiado el workspace owner correctamente.',
          {
            title: 'Asignación completada.',
            variant: 'success',
            autoHideDelay: 5000
          }
        )
      })
      .catch((error) => {
        let messageValues = {
          title: 'Error en el cambio de cliente.',
          message: '',
          delay: 6000,
          error: error
        }
        new MessageError({ propsData: messageValues }).displayMessage()
      })
      .finally(() => {
        this.changingOwner = false
        this.hideOwnerToast()
      })
  }

  onCancel () {
    this.$emit('close')
  }

  displayChangeOwnerModal () {
    this.displayChangeOwnerMessage = !this.displayChangeOwnerMessage
    if (!this.displayChangeOwnerMessage) this.confirmChangeOwner = false
  }

  hideOwnerToast () {
    setTimeout(() => {
      this.ownerChanged = false
    }, 4000)
  }
}
</script>

<style scoped lang="scss">
.form-area.collapsed {
  width: calc(50% - 10px) !important;
}
.workspace-form-modal {
  background-color: #fff;
  z-index: 2;
  padding: 75px 20px 20px 20px;
  border-left: 1px solid #dfdfdf;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  min-width: 450px;
  width: 50%;
  overflow-y: auto;
}
.workspaces-table tr {
  cursor: pointer;
}
.workspaces-table tr th {
  font-size: 0.9rem;
}
.workspaces-table tr.selected {
  background-color: var(--primary-color);
  color: #fff;
}

.workspace-actions {
  margin: 24px 10px 0 32px;
  width: fit-content;
  padding: 8px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 5px 2px #ddd;

  .col {
    padding: 0;
  }

  .workspace-action {
    height: 48px;
    border-right: 1px solid #ddd;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 300;
    i {
      margin: 0 3px;
      font-size: 1.1rem;
    }
    &:hover, &.active {
      background-color: #f0f0f0;
    }
    &.disabled {
      opacity: 0.35;
      pointer-events: none;
    }
  }
}
.change-domain-owner__modal {
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
  z-index: 10;
  &.active {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  & > .content {
    position: relative;
    background-color: #fefefe;
    margin: 10% auto;
    border: 1px solid #888;
    border-radius: 1rem;
    width: 75%;
    min-width: 320px;
    max-width: 450px;

    & > .modal__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 3rem;
      p {
        padding: 0 1.4rem;
        margin: 0;
        font-size: 1.2rem;
        font-weight: bold;
      }
      button {
        border-radius: 0 1rem 0 0;
      }
    }
    & > .confirmation-messsage {
      padding: 0.5rem 1.4rem;
      margin: 0;
      .client, .domain {
        padding: 0.2rem;
        border-radius: 4px;
        font-weight: 600;
      }
    }
    & > .confirm-message {
      padding: 1.2rem;
      .custom-control-input {
        left: 1.2rem;
      }
    }
    & > .actions {
      height: 3.2rem;
      .cancel {
        height: 3.2rem;
        border-radius: 0 0 0 1rem;
      }
      .confirm {
        height: 3.2rem;
        border-radius: 0 0 1rem 0;
      }
    }
  }
}
.toast.owner-toast {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 999;

  &.success .toast-body {
    p {
      margin: 0
    }
    span {
      font-weight: bold;
    }
  }
  &.success .toast-header {
    background-color: #c3e6cb;
    color: #155724;
  }
  &.success .toast-body {
    background-color: #d4edda;
    border-color: #c3e6cb;
    color: #155724;
  }
}
</style>
